var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Phone",
    transform: "translate(-134 -381)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8285",
    "data-name": "Rectangle 8285",
    width: 24,
    height: 24,
    transform: "translate(134 381)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30752",
    "data-name": "Path 30752",
    d: "M7.95,16.876c2.814,2.817,6.221,4.981,9,4.981a4.17,4.17,0,0,0,3.225-1.4A2.88,2.88,0,0,0,21,18.568a1.594,1.594,0,0,0-.672-1.339l-2.934-2.084a2.159,2.159,0,0,0-1.191-.471,1.9,1.9,0,0,0-1.283.689l-.687.681a.521.521,0,0,1-.366.153.868.868,0,0,1-.392-.11,14.788,14.788,0,0,1-2.582-2.154,14.065,14.065,0,0,1-2.147-2.574.9.9,0,0,1-.11-.39.5.5,0,0,1,.145-.36l.689-.7a1.918,1.918,0,0,0,.689-1.283,2.139,2.139,0,0,0-.487-1.191l-2.06-2.9a1.645,1.645,0,0,0-1.386-.694,2.706,2.706,0,0,0-1.861.828A4.3,4.3,0,0,0,3,7.9C3,10.686,5.133,14.07,7.95,16.876Z",
    transform: "translate(134 380.154)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/Phone.c44df4abb69ddf7a4b5391bcc86d45bb.svg";
export { ForwardRef as ReactComponent };